const LoaderOverlay = () => {
  return (
    <div className="loading-background">
      <div className="loader" />
    </div>
  )
}

export default LoaderOverlay
